import { Link } from "react-router-dom";
import "../styles.css";
import { useEffect, useState } from "react";
import PhotoAlbum from "react-photo-album";
import ReactImageVideoviewer from '../simple_viewer/index.js';
import { getParentId, IS_PERSO_SITE } from '../App.js';
import DATA from '../config/new_data.json';
import { useEditorMode } from './EditorMode.js';
import { EditorFloatingButtons } from './EditorMode.js';

export default function Album({ category }) {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    isEditMode,
    editTitles,
    handleTitleChange,
    enterEditMode,
    clearAllChanges,
    savePatchFile,
    hasChanges,
  } = useEditorMode(category);

  const mediaItems = DATA[category]
    .map((item, index) => ({ src: item.poster, width: item.width, height: item.height, type: item.type, item, id: index }));
  const mediaData = mediaItems.map(({ item }) => item);

  useEffect(() => {
    setCurrentIndex(0);
  }, [category]);

  useEffect(() => {
    if (!isViewerOpen || !mediaData[currentIndex]) {
      return;
    }

    document.title = _formatPageTitle(mediaData[currentIndex]);
  }, [isViewerOpen, currentIndex, mediaData]);

  const openViewer = (index) => {
    setCurrentIndex(index);
    setIsViewerOpen(true);
  };

  return (
    <div className="App">
      <EditorFloatingButtons
        savePatchFile={savePatchFile}
        clearAllChanges={clearAllChanges}
        hasChanges={hasChanges}
        isEditMode={isEditMode}
      />
      {!IS_PERSO_SITE && <Link className="link-header"  to={'/' + getParentId(category)}>Retour</Link>}
      <hr />
      <PhotoAlbum
        layout="rows"
        photos={mediaItems}
        renderPhoto={({ photo, wrapperStyle, renderDefaultPhoto }) => (
          <a
            href={photo.href}
            style={wrapperStyle}
            className={photo.item.type === 'video' ? 'video-thumbnail' : ''}
            id={photo.id}
            onClick={(event) => {
              event.preventDefault();
              if (!isEditMode) openViewer(photo.id);
            }}
          >
            {renderDefaultPhoto({ wrapped: true })}
            {isEditMode ? (
              <div>
                <input
                  type="text"
                  value={editTitles[photo.id] ?? _formatPageTitle(photo.item)}
                  onChange={e => handleTitleChange(photo.id, e.target.value)}
                  style={{ fontSize: '1.1em', width: '90%' }}
                />
              </div>
            ) : (
              <h3
                onDoubleClick={enterEditMode}
                style={{ cursor: 'pointer' }}
              >{editTitles[photo.id] ?? _formatPageTitle(photo.item)}</h3>
            )}
          </a>
        )}
      />
      {isViewerOpen && (
        <ReactImageVideoviewer
          data={mediaData}
          startIndex={currentIndex}
          showResourceCount={true}
          onCloseCallback={() => setIsViewerOpen(false)}
          onNavigationCallback={(currentIndex) => {
            document.title = _formatPageTitle(mediaData[currentIndex]);
            document.getElementById(currentIndex).scrollIntoView({ behavior: 'smooth', block: 'center' });
          }}
        />
      )}
      <hr />
      {!IS_PERSO_SITE && <Link className="link-header"  to={'/' + getParentId(category)}>Retour</Link>}
    </div>
  );
}

function _formatPageTitle(item) {
  return item.date && item.title ? `${item.date} - ${item.title}` : (item.date || item.title);
}
